import React, { useState } from 'react';
import { ChevronDown, ChevronUp, HelpCircle, Lock, Check } from 'lucide-react';
import { Button } from '../ui/Button';
const faqs = [{
  q: '¿Cómo recibo el UltraPack después de comprarlo?',
  a: 'El UltraPack es 100% digital. Apenas se acredita el pago, recibís un correo electrónico con acceso inmediato para descargar los 6 tomos y los 6 bonos desde cualquier celular, tablet o computadora.'
}, {
  q: '¿Para qué edad es el UltraPack?',
  a: 'Está diseñado para acompañar el desarrollo del habla desde los 0 hasta los 3 años, con 6 tomos organizados por etapas para que siempre sepas qué actividad hacer según la edad de tu hijo.'
}, {
  q: '¿Necesito tener experiencia en estimulación o ser profesional?',
  a: 'No. El UltraPack fue creado para madres y padres, no para especialistas. Solo tenés que seguir las actividades paso a paso.'
}, {
  q: '¿Cuánto tiempo necesito por día?',
  a: 'Solo 10 minutos al día. Las actividades están pensadas para integrarse fácilmente a la rutina, sin materiales costosos ni preparaciones complicadas.'
}, {
  q: '¿Y si mi hijo ya tiene más de 18 meses?',
  a: 'También sirve. El sistema incluye tomos específicos hasta los 36 meses, por lo que podés empezar directamente desde la etapa en la que se encuentra hoy.'
}, {
  q: '¿Qué pasa si lo compro y no era lo que esperaba?',
  a: 'Comprás con total tranquilidad. Tenés 7 días de garantía. Si sentís que el UltraPack no cumple con tus expectativas, nos escribís y te devolvemos el 100% de tu dinero. Sin preguntas y sin vueltas.'
}];
const closingBullets = ['Los 6 tomos del UltraPack Activador del Habla.', 'Los 6 bonos exclusivos.', 'Acceso inmediato.', 'Garantía de 7 días.'];
function scrollToCheckout() {
  document.getElementById('comprar')?.scrollIntoView({
    behavior: 'smooth'
  });
}
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 px-5 bg-stone-50" data-id="element-85">
      <div className="text-center mb-10" data-id="element-86">
        <HelpCircle className="w-10 h-10 text-violet-500 mx-auto mb-4" data-id="element-87" />
        <h2 className="text-2xl font-bold text-gray-900" data-id="element-88">
          Preguntas Frecuentes
        </h2>
      </div>

      <div className="space-y-3 mb-12" data-id="element-89">
        {faqs.map((faq, index) => <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden" data-id="element-90">
            <button className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-91">
              <span className="font-bold text-gray-900 pr-4" data-id="element-92">{faq.q}</span>
              {openIndex === index ? <ChevronUp className="w-5 h-5 text-violet-500 flex-shrink-0" data-id="element-93" /> : <ChevronDown className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-94" />}
            </button>

            {openIndex === index && <div className="px-5 pb-4 text-gray-600 text-sm leading-relaxed" data-id="element-95">
                {faq.a}
              </div>}
          </div>)}
      </div>

      {/* Closing */}
      <div className="bg-white p-6 rounded-3xl shadow-xl border border-violet-100 text-center" data-id="element-96">
        <p className="text-lg font-bold text-gray-900 mb-4 leading-snug" data-id="element-97">
          Tu hijo no necesita horas de estimulación. Necesita constancia, un
          método y que alguien lo acompañe.
        </p>
        <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-98">
          Con solo 10 minutos al día, hoy podés empezar a crear esos pequeños
          momentos que ayudan a desarrollar el habla de una forma natural,
          práctica y adaptada a cada etapa.
        </p>

        <div className="text-left bg-violet-50 rounded-2xl p-5 mb-6 border border-violet-100" data-id="element-99">
          <p className="font-bold text-gray-900 mb-3" data-id="element-100">Hoy recibís:</p>
          <ul className="space-y-2" data-id="element-101">
            {closingBullets.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-700" data-id="element-102">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-103" />
                {item}
              </li>)}
          </ul>
        </div>

        <div className="bg-violet-600 text-white rounded-2xl p-5 mb-6" data-id="element-104">
          <p className="font-extrabold text-sm uppercase tracking-wide mb-3" data-id="element-105">
            🎁 Oferta especial — 70% OFF | Solo 20 cupos disponibles
          </p>
          <p className="text-4xl font-extrabold leading-none" data-id="element-106">$23.990 ARS</p>
          <p className="text-sm text-violet-200 mt-1" data-id="element-107">
            Valor real <span className="line-through" data-id="element-108">$84.000</span>
          </p>
        </div>

        <p className="flex items-center justify-center gap-1.5 text-xs text-gray-500 font-medium mb-4" data-id="element-109">
          <Lock className="w-3.5 h-3.5 text-green-500" data-id="element-110" />
          Compra 100% segura · Acceso inmediato · Garantía de 7 días
        </p>

        <Button variant="green" onClick={scrollToCheckout} data-id="element-111">
          <span className="text-lg" data-id="element-112">QUIERO EL ULTRAPACK AHORA</span>
        </Button>

        <p className="text-sm font-semibold text-violet-600 mt-4" data-id="element-113">
          ⭐ +4.372 familias ya descargaron el UltraPack
        </p>

        <div className="border-t border-gray-100 mt-6 pt-6" data-id="element-114">
          <div className="text-xs text-gray-400 space-y-1" data-id="element-115">
            <p data-id="element-116">@ultrapack.digital</p>
            <p data-id="element-117">soporte@ultrapack-digital.com</p>
          </div>
        </div>
      </div>
    </section>;
}